export default "__VITE_ASSET__Dqf2yL7K__"